import { get } from '../../apiClient';

const orderDashboardService = {
    /**
     * Get complete dashboard overview
     */
    getDashboardOverview: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.companyId) queryParams.append('companyId', params.companyId);
            if (params.dateRange) queryParams.append('dateRange', params.dateRange);
            if (params.startDate) queryParams.append('startDate', params.startDate);
            if (params.endDate) queryParams.append('endDate', params.endDate);

            const url = `/crm/orders/dashboard/overview?${queryParams.toString()}`;
            const response = await get(url);

            return {
                success: response.success || response.responseCode === 200,
                data: response.data || {}
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to fetch dashboard overview',
                data: {}
            };
        }
    },

    /**
     * Get order overview stats
     */
    getOrderOverview: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.companyId) queryParams.append('companyId', params.companyId);

            const url = `/crm/orders/dashboard/order-overview?${queryParams.toString()}`;
            const response = await get(url);

            return {
                success: response.success || response.responseCode === 200,
                data: response.data || {}
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to fetch order overview',
                data: {}
            };
        }
    },

    /**
     * Get inventory status
     */
    getInventoryStatus: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.companyId) queryParams.append('companyId', params.companyId);

            const url = `/crm/orders/dashboard/inventory-status?${queryParams.toString()}`;
            const response = await get(url);

            return {
                success: response.success || response.responseCode === 200,
                data: response.data || {}
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to fetch inventory status',
                data: {}
            };
        }
    },

    /**
     * Get dispatch status
     */
    getDispatchStatus: async () => {
        try {
            const url = `/crm/orders/dashboard/dispatch-status`;
            const response = await get(url);

            return {
                success: response.success || response.responseCode === 200,
                data: response.data || {}
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to fetch dispatch status',
                data: {}
            };
        }
    },

    /**
     * Get batch status
     */
    getBatchStatus: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.companyId) queryParams.append('companyId', params.companyId);

            const url = `/crm/orders/dashboard/batch-status?${queryParams.toString()}`;
            const response = await get(url);

            return {
                success: response.success || response.responseCode === 200,
                data: response.data || {}
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to fetch batch status',
                data: {}
            };
        }
    },

    /**
     * Get recent orders
     */
    getRecentOrders: async (params = {}) => {
        try {
            const queryParams = new URLSearchParams();
            if (params.companyId) queryParams.append('companyId', params.companyId);
            if (params.limit) queryParams.append('limit', params.limit);

            const url = `/crm/orders/dashboard/recent-orders?${queryParams.toString()}`;
            const response = await get(url);

            return {
                success: response.success || response.responseCode === 200,
                data: response.data || []
            };
        } catch (error) {
            
            return {
                success: false,
                error: error.message || 'Failed to fetch recent orders',
                data: []
            };
        }
    }
};

export default orderDashboardService;
